module.exports = __webpack_public_path__ + "img/july-4.655278c5.jpg";